<template>
  <!-- can-cancel = ['escape', 'x', 'outside'] si se quiere que cierre  por cualqiera de esos [] caso contrario -->
  <b-modal :active.sync="isModalActive" :width="640" scroll="keep" :can-cancel="[]">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
    <div class="rounded-lg shadow-xl bg-white overflow-hidden border border-gray-200 border-[#E4E6EB]">
      <!-- HEADER sin fondo gris -->
      <header class="flex justify-between items-start flex-wrap gap-2 text-sm font-medium text-gray-800 px-4 py-4 border-b border-[#E4E6EB] uppercase tracking-wide">
        <div class="flex-1 min-w-0">
          <h2 class="break-words whitespace-normal">
            {{ $t('progress_summary') }}
          </h2>
        </div>
        <div class="flex-shrink-0">
        </div>
      </header>

      <div class="px-4 py-4 space-y-4 bg-white">
        <progress-summary-layer ref="refProgressSummaryLayer"
          :layer="data"
        />
      </div>

      <footer class="px-4 py-4 border-t border-[#E4E6EB] bg-white">
        <div class="w-full flex justify-between-x justify-end space-x-2">
          <v-button v-if="!processingData && false" @click="handleAction()" :icon="iconName" size="is-small">{{ computedTextAction }}</v-button>
          <v-button v-if="!processingData" color="grey" icon="door-closed" size="is-small" @click="isModalActive = false">{{ $t('close') }}</v-button>

          <v-button-processing v-if="processingData" />
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import ProgressSummaryLayer from './progress-summary-layer.vue';

export default {
  components: {
    ProgressSummaryLayer
  },

  props: {
    textAction: {
      type: String,
      default: null
    },
    iconName: {
      type: String,
      default: 'plus'
    }
  },

  data() {
    return {
      isModalActive: false,
      isLoading: false,
      processingData: false,

      data: null,
      codeLayer: null,
    }
  },

  computed: {
    computedTextAction() {
      return this.textAction || this.$t('accept');
    }
  },

  created() {
  },

  methods: {

    async handleActionRemote() {
      this.processingData = true;

      try {
        // Aquí se puede agregar la lógica para guardar el grupo
        // Por ejemplo, una llamada a la API para crear o actualizar el grupo

        this.$emit('epc-group-status-modal-close');
        this.hide();
      } catch (error) {
        console.error('Error al guardar el grupo:', error);
      } finally {
        this.processingData = false;
      }
    },

    async handleAction() {
      this.processingData = true;
      const data = Object.assign({}, this.data, this.$refs.refLayerStatusesConfigForm.getData());
      this.$emit('epc-perform-action', { config: data, codeLayer: this.codeLayer });
      this.processingData = false;
      this.hide();

    },

    show(data) {
      this.data = data;
      this.isModalActive = true;
    },

    hide() {
      this.data = null;

      this.isModalActive = false;

    }
  }
};
</script>
<style scoped>
/* Oculta los botones para aumentar los inputs numéricos */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>
